import { __decorate, __metadata, __param } from "tslib";
import { BooleanEx, E_BoolEx } from '@/@core/utils/boolex';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import _ from 'lodash';
let IllegalManagementService = class IllegalManagementService {
    constructor(illegalManagementApi, i18n) {
        this.illegalManagementApi = illegalManagementApi;
        this.i18n = i18n;
    }
    /**
    * 查询违规IP列表
    **/
    getCarsiSuspectSellIPList(params) {
        return this.illegalManagementApi.getCarsiSuspectSellIPList(params);
    }
    /**
    * 新增违规IP
    **/
    postAddCarsiSuspectSellIP(params) {
        return this.illegalManagementApi.postAddCarsiSuspectSellIP(params);
    }
    /**
     * 删除违规IP
     */
    deleteCarsiSuspectSellIP(ip) {
        return this.illegalManagementApi.deleteCarsiSuspectSellIP(ip);
    }
    /**
     * 查询违规公司列表
     */
    getCarsiSuspectSellTenantList(params) {
        return this.illegalManagementApi.getCarsiSuspectSellTenantList(params);
    }
    /**
     * 新增违规公司
     */
    postAddCarsiSuspectSellTenant(params) {
        return this.illegalManagementApi.postAddCarsiSuspectSellTenant(params);
    }
    /**
     * 删除违规公司
     */
    deleteCarsiSuspectSellTenant(tenant_id) {
        return this.illegalManagementApi.deleteCarsiSuspectSellTenant(tenant_id);
    }
    /**
     * 查询违规用户列表
     */
    getCarsiSuspectSellUserList(params) {
        const s_deleted = BooleanEx.toBool(params.s_deleted);
        const filterParams = _.pickBy({ ...params, s_deleted }, val => _.isBoolean(val) || !_.isEmpty(val) || _.isNumber(val));
        return this.illegalManagementApi.getCarsiSuspectSellUserList(filterParams);
    }
    /**
     * 删除违规用户
     */
    deleteCarsiSuspectSellUser(tenant_user_id, remove_remark) {
        return this.illegalManagementApi.deleteCarsiSuspectSellUser(tenant_user_id, remove_remark);
    }
    /**
     * 编辑黑名单公司列表
     */
    editCarsiSuspectSellTenant(params) {
        return this.illegalManagementApi.editCarsiSuspectSellUser(params);
    }
    get accountStatusOptions() {
        return [{
                label: this.i18n.t('backoffice.common.disable'),
                value: E_BoolEx.FALSE,
            }, {
                label: this.i18n.t('backoffice.common.relieved'),
                value: E_BoolEx.TRUE,
            }];
    }
};
IllegalManagementService = __decorate([
    injectable(),
    __param(0, inject(Symbols.IllegalManagementApi)),
    __param(1, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object])
], IllegalManagementService);
export { IllegalManagementService };
